if (window.Groupon == null) {
  window.Groupon = {};
}

if (Groupon.Performance == null) {
  Groupon.Performance = {};
}

Groupon.Performance.pageReady = function() {
  if (typeof BOOMR.page_ready === 'function') {
    return BOOMR.page_ready();
  } else {
    return BOOMR.t_done = new Date().getTime();
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvcGVyZm9ybWFuY2UuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvcGVyZm9ybWFuY2UuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLElBQTJCLHNCQUEzQjtFQUFBLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLEdBQWpCOzs7O0VBQ0EsT0FBTyxDQUFDLGNBQWU7OztBQUV2QixPQUFPLENBQUMsV0FBVyxDQUFDLFNBQXBCLEdBQWdDLFNBQUE7RUFDOUIsSUFBRyxPQUFPLEtBQUssQ0FBQyxVQUFiLEtBQTJCLFVBQTlCO1dBQ0UsS0FBSyxDQUFDLFVBQU4sQ0FBQSxFQURGO0dBQUEsTUFBQTtXQUdFLEtBQUssQ0FBQyxNQUFOLEdBQW1CLElBQUEsSUFBQSxDQUFBLENBQU0sQ0FBQyxPQUFQLENBQUEsRUFIckI7O0FBRDhCIn0=
